import { FormControl, FormHelperText, FormLabel, Stack } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import * as React from 'react';
import "./datepicker.css";


export default function CustomizedDatePicker({ values, setFormValues, error, required, title, name, label, check, disabled, InputProps, clearIcon }) {
    const outerTheme = createTheme({

    });
    const handleDateChange = (e) => {
        if (e === null) {
            setFormValues((prevValues) => ({
                ...prevValues,
                [name]: ""
            }))
        } else {
            const date = e
            const momentDate = moment(date, 'ddd MMM DD YYYY hh:mm:ss [GMT]ZZ (zz)');
            const isoString = momentDate.format('YYYY-MM-DD');
            setFormValues((prevValues) => ({
                ...prevValues,
                [name]: isoString
            }))
        }

    }
    return (
        <Stack direction={"column"} >
            <FormControl variant="outlined" fullWidth>
                {title && <FormLabel>{title}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>}
                <ThemeProvider theme={outerTheme}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            slotProps={{ field: { clearable: true } }}
                            value={(values === '' || values === null)? null : new Date(values)}
                            hiddenLabel={true}
                            disabled={disabled}
                            InputProps={InputProps}
                            format={"dd/MM/yyyy"}
                            // onChange={(e) => check ? handlecheck(e) : setFormValues((prevValues) => ({
                            //     ...prevValues,
                            //     [name]: moment(e, 'YYYY-MM-DD hh:mm:ss').toDate()
                            // }))}
                            label={label}
                            onChange={(e) => handleDateChange(e)}
                            sx={{
                                '& .MuiInputBase-input': {
                                    color: "#000000DE",
                                    // height: "5.5px",
                                    fontSize: "14px",
                                },
                                '& .MuiSvgIcon-root': {
                                    width: "17px",
                                    height: "17px",
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: "#e9ecee",
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'black', // Focus state
                                },
                                "& .MuiFormLabel-root": {
                                    fontSize: "1rem",
                                    top: "-7px",
                                },
                                "& .Mui-selected.Mui-disabled": {
                                    color: "rgba(0, 0, 0)" // (default alpha is 0.38)
                                },
                            }}
                            control={(params) => <TextField size="small" InputProps={InputProps} {...params} />}
                        />
                    </LocalizationProvider>
                </ThemeProvider>
            </FormControl>
            {error && <FormHelperText sx={{ color: "red" }}>{error || ""}</FormHelperText>}
        </Stack>


    );
}
